import classNames from "classnames/bind";
import styles from "./ConfigZone.module.css";
import { useContext, useEffect, useState } from "react";
import { Alert, Button, Loading, Toast } from "../../../../../../components";
import { aiConfigFRS } from "../../../../../../services/api/aiConfigFRS";
import { getPolygon, getRoiList, validatorDataIsNumber } from "../../../../../../utils";
import CanvasDraw from "./CanvasDraw";
import { streamFSR } from "../../../../../../services/api/streamFSR";
import { useTranslation } from "react-i18next";
import { configFrsUniview } from "../../../../../../services/api/configFrsUniview";

const cx = classNames.bind(styles)
const univiewUnit = 10000;

const ConfigZone = ({ cameraCode, ...props }) => {
    // const { cameraCode } = useContext(LisencePlateManagerContext);
    const { onClose, motionStatus, handleTurnOnMotion, companyOfCam } = props;
    const [listPolygon, setListPolygon] = useState({
        polygon1: [],
        polygon2: [],
        polygon3: []
    })
    const [path, setPath] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [cropRegion, setCropRegion] = useState(0);
    const [defaultShape, setDefaultShape] = useState();
    const [reFresh, setRefresh] = useState(false);
    const [confirmDefault, setConfirmDefault] = useState(false);
    const [config, setConfig] = useState();
    const { t } = useTranslation();
    let width = 491;
    let height = 279;
    let ratioX = width / univiewUnit;
    let ratioY = height / univiewUnit;

    const getConfigRoi = async () => {
        try {
            const param = {
                camera_code: cameraCode
            }
            const res = await configFrsUniview.get(param);
            if (res) {
                setConfig(res);
                if (res?.EntireImageEnabled === 0) {
                    const valueConfig = res.Polygons[0]?.Points;
                    const data = valueConfig?.map(({ X, Y }) => {
                        return [X * ratioX, Y * ratioY]
                    });
                    // fix cứng 100 để nó ko tính theo phần trăm
                    const { polygon1, polygon2, polygon3 } = getPolygon([data], 100, 100);
                    setListPolygon({ polygon1, polygon2, polygon3 })
                }
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            // console.log(error);
            Toast.open("Lấy cấu hình không thành công", "danger")
        }
    }
    const getPathStreaming = async () => {
        try {
            const param = {
                cameraCodes: [cameraCode]
            }
            const res = await streamFSR.postListCodeCam(param)
            if (res && res.stream) {
                setPath(res.stream[0].data[0].PATH);
            }
        } catch (error) {
            Toast.open('Không có hình ảnh', 'danger')
        }
    }
    useEffect(() => {
        getConfigRoi()
        getPathStreaming()
    }, [reFresh, cameraCode])

    const handleUpdate = async (infoPolygon) => {
        let { polygon1, polygon2, polygon3 } = infoPolygon;
        let data1 = [];
        if (polygon1.length === 5) {
            polygon1.shift();
            const arr = polygon1.map(item => {
                return { X: Math.ceil(item.x1 / ratioX), Y: Math.ceil(item.y1 / ratioY) };
            })
            data1.push(arr);
        }
        const polygons = config?.Polygons?.map(poly => {
            return {
                ...poly,
                Points: data1[0]?.length > 0 ? data1[0] : [],
                PointNum: data1[0]?.length
            }
        });
        try {
            setIsLoading(true)
            const infoConfig = {
                ...config,
                Polygons: polygons,
                EntireImageEnabled: data1?.length > 0 ? 0 : 1
            }
            const param = {
                camera_code: cameraCode
            }
            await configFrsUniview.put(param, infoConfig);
            Toast.open(`Cài đặt Nhận dạng khuôn mặt thành công`, 'success');
            setIsLoading(false);
            // setReGetData(!reGetData)
        } catch (error) {
            setIsLoading(false);
            // console.log(error);
            Toast.open('Cài đặt Nhận dạng khuôn mặt không thành công', 'danger');
        }
    }
    const handleChagePolygon = (value) => {
        setListPolygon(value)
    }
    const handleShowConfirmDefault = () => {
        setConfirmDefault(!confirmDefault)
    }
    const handleSetDefault = async () => {
        handleShowConfirmDefault()
        setCropRegion(0)
        await handleUpdate({
            polygon1: [],
            polygon2: [],
            polygon3: []
        })
        setRefresh(!reFresh)
    }

    const handleCancel = () => {
        setRefresh(!reFresh)
        setIsLoading(true)
        setCropRegion(0)
        setListPolygon({
            polygon1: [],
            polygon2: [],
            polygon3: []
        })
        if (onClose) {
            onClose()
        }
    }

    const handleAccept = () => {
        handleUpdate(listPolygon)
    }

    return (
        <>
            {confirmDefault && <Alert title={"Xác nhận cài lại mặc định"}
                onClose={handleShowConfirmDefault}
                onOk={handleSetDefault}
            />}
            <CanvasDraw
                polygon={listPolygon}
                onChange={handleChagePolygon}
                path={path}
                width={width}
                height={height}
                cropRegion={cropRegion}
                setCropRegion={(value) => setCropRegion(value)}
                defaultShape={defaultShape}
                setDefaultShape={(val) => setDefaultShape(val)}
            />
            <div className={cx('footer')}>
                {/* <Button
                    title={t('setting.Reset_to_default')}
                    className={cx("btn-save")}
                    onClick={handleShowConfirmDefault}
                /> */}
                <Button
                    title={t('stream.cancelCustom')}
                    className={cx("btn-cancle")}
                    onClick={handleCancel}
                />
                <Button
                    title={t('settingCam.Save_settings')}
                    className={cx("btn-save")}
                    onClick={handleAccept}
                />
            </div>
            {isLoading && <div className={cx('modal_loading')}><Loading /></div>}
        </>
    )
}

export default ConfigZone;